export const opcionesPorOperacion = {
  EmpresaPrueba: [
    {
      Pagos: [
        "Gas",
        "Agua",
        "Luz",
        "Alquiler",
        "Impuestos",
        "Pago de plataformas de delivery",
        "Pago de mantenimiento de equipos",
        "Pago de Sistemas de gestion",
        "Pago de publicidad o marketing",
        "Pago de préstamos o créditos",
        "Pago de sueldos y jornales",
        "Pago de Internet y telefonia",
      ],
      Compras: [
        "Alimentos frescos (carnes, verduras, lácteos)",
        "Alimentos Producidos",
        "Bebidas y gaseosas",
        "Panificados",
        "Insumos para cocina (aceite, condimentos, harinas)",
        "Café",
        "Envases descartables (cajas, bandejas, vasos)",
        "Bolsas, servilletas, cubiertos plásticos",
        "Productos de limpieza",
      ],
      Ingresos: [
        "Ingresos por ventas", 
        "Ingresos por capital aportado"
      ]
    }
  ],
  DivaEstetica: [
    {
      Pagos: [
        "Sueldos y jornales",
        "Mantenimiento de Equipos",
        "Pago de Publicidad o Marketing",
        "Pago de prestamos o Créditos",
        "Pago de Internet o Telefonía",
        "Pago de Sistemas de Gestión",
        "Otros"
      ],
      Compras: [
        "Elementos de Higiene",
        "Elementos de Trabajo",
        "Aceites, Líquidos y Soluciones",
        "Cremas",
        "esmaltes, Geles y Primers",
        "Polvo y adornos",
        "Uñas (Softgel y Poligel)",
      ],
      Ingresos: [
        "Ingresos por ventas", 
        "Ingresos por capital aportado"
      ]
    }
  ],
  RomboLubricentro: [
    {
      Pagos: [
        "Mantenimiento de equipos",
        "Alquiler del local o expensas",
        "Servicios",
        "Sueldos y jornales",
        "Servicios profesionales",
        "Impuestos",
        "Pago de Publicidad o Marketing",
        "Pago de Préstamos o Créditos",
        "Pago de Internet y Telefonia",
        "Pago de Sistemas de Gestion",
        "Otros",
      ],
      Compras: [
        "Aceites y lubricantes",
        "Filtros",
        "Aditivos y productos químicos",
        "Repuestos básicos",
        "Productos de limpieza automotor",
        "Papelería y materiales de oficina",
        "Herramientas y equipos",
        "Envases y embalajes",
      ],
      Ingresos: [
        "Ingresos por ventas", 
        "Ingresos por capital aportado"
      ]
    }
  ],
};
